const email_logs = {
  permissionSource: 'api::email-log.email-log',
  creationTitle: 'Create Email History',
  creationEndPoint: '/email-logs',
  detailTitle: 'Email History',
  detailEndPoint: '/email-logs/:id?populate=*',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'smtp_username',
              value: 'smtp_username',
              tag: 'input',
              disabled: true,
            },
            {
              label: 'From',
              value: 'from_email',
              tag: 'input',
              disabled: true,
            },
          ],
        },
        {
          label: 'To',
          value: 'to_email',
          tag: 'input',
          disabled: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Subject',
          value: 'subject',
          tag: 'input',
          disabled: true,
        },
        {
          label: 'Status',
          value: 'status',
          tag: 'input',
          disabled: true,
        },
        {
          label: 'Type',
          value: 'type',
          tag: 'input',
          disabled: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Detail',
          value: 'detail',
          tag: 'richTextarea',
          disabled: true,
        },
        {
          label: 'Attachments',
          value: 'attachments',
          tag: 'multi-media',
          disabled: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}

export default email_logs
